import { useEffect, useState } from "react";

export function useAnimationClass(className:string):[string, ()=>void]{
    const [currentClass, setCurrentClass] = useState("");
    const [version, setVersion] = useState(0);

    useEffect(()=>{
        setCurrentClass(className);
        const c = setTimeout(()=> setCurrentClass(""), 300)
        return () => clearTimeout(c);
    }, [version])

    return [currentClass, () => setVersion(version + 1)];
}

export function useErrorAlert():[string, (error:string) => void, string]{
    const [error, setError] = useState("");
    const [shakeClass, animateShake] = useAnimationClass("shake")

    return [error, (e:string) => {animateShake(); setError(e);}, shakeClass]
}